import { Component } from 'preact'
import DynamicSaveBar from '../../ui-components/DynamicSaveBar'
import KnowledgeBaseContentList from './KnowledgeBaseContentList'
import axios from 'axios'
import ArticleIcon from '../../assets/icon-content-type-article'
import QuestionIcon from '../../assets/icon-content-type-question'
import AnswerIcon from '../../assets/icon-content-type-answer'
import DiscussionIcon from '../../assets/icon-content-type-discussion'
import IdeaIcon from '../../assets/icon-content-type-idea'

import {
  arrayMove,
  SortableContainer,
  SortableElement
} from 'react-sortable-hoc'

const SortableList = SortableContainer(({ children }) => children)
const SortableItem = SortableElement(({ children }) => children)

class KnowledgeBaseContent extends Component {
  constructor (props) {
    super(props)
    this.state = {
      errors: [],
      list: props.list,
      savedList: props.list,
      showModal: false,
      showConfirmation: false,
      isLoading: false
    }
    this.saveCategory = this.saveCategory.bind(this)
    this.resetChanges = this.resetChanges.bind(this)
  }

  resetChanges () {
    this.setState({ list: this.state.savedList })
  }

  saveCategory () {
    this.setState({ isLoading: true })

    const idList = this.state.list.map(item => item.id)

    const params = {
      order: idList,
      category: this.props.categoryId
    }

    axios.post('/platform/knowledge-base/topicsOrder', params)
      .then(() => {
        this.state.savedList = this.state.list
        this.setState({ isLoading: false })
        this.props.showMessage('success')
        this.props.updateCategory({ order: this.state.list })
      })
      .catch((e) => {
        this.setState({ isLoading: false })
        this.props.showMessage('error')
      })
  }

  hasChanged () {
    return JSON.stringify(this.state.savedList) !== JSON.stringify(this.state.list)
  }

  onSortEnd ({ oldIndex, newIndex }) {
    const newList = arrayMove(this.state.list, oldIndex, newIndex)
    this.setState({ list: newList })
  }

  componentDidUpdate () {
    this.props.hasTabChanges(this.hasChanged())
  }

  componentDidMount () {
    this.props.saveUpdates(this.saveCategory)
    this.props.discardChanges(this.resetChanges)

    if (!this.state.list) {
      axios.get('/platform/knowledge-base/getContent', { params: { category: this.props.categoryId } })
        .then((response) => {
          this.setState({
            list: response.data.content,
            savedList: response.data.content
          })
          this.props.updateCategory({ order: this.state.list })
        })
        .catch(() => {
        })
    }
  }

  render (props, state) {
    const displaySaveBar = this.hasChanged()
    const topicType = {
      'question': <QuestionIcon />,
      'article': <ArticleIcon />,
      'answer': <AnswerIcon />,
      'discussion': <DiscussionIcon />,
      'idea': <IdeaIcon />
    }

    if (!state.list) {
      return null
    }

    return (
      <div className='content'>
        <p>All the articles in this category will be shown in this list.</p>
        {
          state.list.length ? (
            <SortableList
              useDragHandle
              lockToContainerEdges
              onSortEnd={(prev, next) => this.onSortEnd(prev, next)}
              lockAxis='y'
              axis='y'
              useWindowAsScrollContainer>
              <ul className='knowledge-base_content-list'>
                {
                  state.list.map((item, idx) => (
                    <SortableItem index={idx} key={item.id}>
                      <KnowledgeBaseContentList
                        {...item}
                        communityUrl={item.url}
                        icon={topicType[item.type]}
                      />
                    </SortableItem>)
                  )
                }
              </ul>
            </SortableList>
          ) : (
            <div className='knowledge-base_empty-content'>No topcis is found in this category. Start by creating a <a href='/content/new/article'>new article</a>.</div>
          )
        }
        {
          displaySaveBar ? (
            <DynamicSaveBar
              isLoading={state.isLoading}
              cancelCallback={this.resetChanges}
              saveCallback={this.saveCategory} />
          ) : null
        }
      </div>
    )
  }
}

export default KnowledgeBaseContent
